import React, { FC, Fragment, useState, useEffect, ComponentType } from 'react';
import { Box, List, ListItem, ListItemButton, Typography } from '@mui/material';
import { ReactComponent as MyAccountIcon } from 'assets/images/SettingsSidebarIcons/my-account.svg';
import { ReactComponent as UserManagementIcon } from 'assets/images/SettingsSidebarIcons/user-management.svg';
import { colorPalette, docGeniusPalette } from 'styles/partials/colors';
import styles from './SettingsSidebar.module.css';

export type Tab = {
  label: string;
  iconName: string;
  component: string;
};

interface IconProps {
  className?: string;
}

interface SettingsSidebarProps {
  tabs: Tab[];
  onChangeTab: (tab: Tab) => void;
}

const iconComponents: { [key: string]: ComponentType<IconProps> } = {
  MyAccountIcon,
  UserManagementIcon,
};

const Icon = (iconName: string) => {
  const IconComponent = iconComponents[iconName as keyof typeof iconComponents];
  return <IconComponent className={`${styles.icon}`} />;
};

const SettingsSidebar: FC<SettingsSidebarProps> = ({ tabs, onChangeTab }) => {
  const [currentTab, setCurrentTab] = useState<Tab>(tabs[0]);

  useEffect(() => {
    onChangeTab(currentTab);
  }, []);

  const selectTab = (tab: Tab) => {
    setCurrentTab(tab);
    onChangeTab(tab);
  };

  return (
    <Fragment>
      <Box className={styles.settingsSideBar} sx={{ backgroundColor: colorPalette.backgroundWhite }}>
        <Typography
          variant='h6'
          component='h1'
          className={styles.settingsTitle}
          sx={{ color: docGeniusPalette.primaryBlue }}
        >
          Settings
        </Typography>
        <List>
          {tabs.map(tab => (
            <ListItem
              key={tab.label}
              disablePadding
              className={styles.listItem}
              sx={{ color: docGeniusPalette.primaryBlue }}
            >
              <ListItemButton
                onClick={() => selectTab(tab)}
                className={`${styles.tab} ${currentTab === tab ? styles.selectedTab : ''}`}
              >
                {Icon(tab.iconName)}
                <div className={`${styles.listItemText} ${currentTab === tab ? styles.selectedTabText : ''}`}>
                  {tab.label}
                </div>
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </Fragment>
  );
};
export default SettingsSidebar;
